function build(txt, img, tre) {
  let struttura = [];
  let temp;

  struttura.push(<h2 className="subtitle" id="h2"> {txt[0]}</h2>);

  temp =
    <div className="paragrafo">
      {txt[1]}
      {img[0]}
    </div>
    ;
  struttura.push(temp);

  temp =
    <div className="paragrafo">
      {img[1]}
      {txt[2]}
    </div>
    ;
  struttura.push(temp);

  temp =
    <div className="paragrafo">
      {txt[3]}
    </div>
    ;
  struttura.push(temp);
//facciata
  struttura.push(<h3 className="sottotitoli"> {txt[4]}</h3>);
  temp =
    <div className="paragrafo">
      {img[2]}
      {txt[5]}
    </div>
    ;
  struttura.push(temp);
  //interno duomo
  struttura.push(<h3 className="sottotitoli" id="cattedrale"> {txt[6]}</h3>);
  temp =
    <div className="paragrafo">
      {txt[7]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {img[3]}
      {img[5]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {txt[8]}
      {img[4]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {txt[9]}
      {img[6]}
    </div>
    ;
  struttura.push(temp);
  //
  temp =
    <div className="paragrafo">
      {txt[10]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {img[7]}
      {img[8]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {txt[11]}
    </div>
    ;
  struttura.push(temp);
  //battistero
  temp =
    <div className="paragrafo">
      {txt[12]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {img[9]}
      {txt[13]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {txt[14]}
      {img[10]}
    </div>
    ;
  struttura.push(temp);
   temp =
  <div className="paragrafo">
    {txt[15]}
  </div>
  ;
struttura.push(temp);
//portalu
struttura.push(<h3 className="sottotitoli"> {txt[16]}</h3>);
temp =
  <div className="paragrafo">
    {img[11]}
    {img[12]}
  </div>
  ;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[17]}
</div>
;
struttura.push(temp);
struttura.push(<h3 className="sottotitoli"> {txt[18]}</h3>);
temp =
  <div className="paragrafo">
    {img[13]}
    {txt[19]}
  </div>
  ;
struttura.push(temp);struttura.push(<h3 className="sottotitoli"> {txt[20]}</h3>);
temp =
  <div className="paragrafo">
   {img[14]}
   {txt[21]}
  </div>
  ;
struttura.push(temp);
//Interno
struttura.push(<h3 className="sottotitoli"> {txt[22]}</h3>);
temp =
  <div className="paragrafo">
    {txt[23]}
    {img[15]}
  </div>
  ;
struttura.push(temp);
temp =
  <div className="paragrafo">
    {txt[24]}
  </div>
  ;
struttura.push(temp);
temp =
  <div className="paragrafo">
    {tre[0]}
    {img[16]}
  </div>
;
struttura.push(temp);
//ciclo mesi
struttura.push(<h3 className="sottotitoli"> {txt[25]}</h3>);
temp =
  <div className="paragrafo">
    {txt[26]}
    {img[20]}
  </div>
  ;
struttura.push(temp);
temp =
  <div className="paragrafo">
    {img[17]}
    {img[18]}
    {img[19]}
  </div>
;
struttura.push(temp);
temp =
  <div className="paragrafo">
      {txt[27]}
    </div>
    ;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {txt[28]}
      {img[21]}
    </div>
    ;
  struttura.push(temp);
  temp =
  <div className="paragrafo">
      {txt[29]}
    </div>
    ;
  struttura.push(temp);
  temp =
  <div className="note">
  {txt[30]}
    </div>
    ;
  struttura.push(temp);
  return struttura;
}

export default build;
